/**
* This file was automatically generated by json-schema-to-typescript.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run json-schema-to-typescript to regenerate this file.
*/

/**
 * JSON Schema for `ng-package.json` description file
 */
export interface NgPackageConfig {
  $schema?: string;
  /**
   * The source folder of an Angular library. This is the folder where a `package.json` is located and defaults to cwd.
   */
  src?: string;
  /**
   * The destination folder to output build artifacts and distributables of an Angular library (default: `dist`).
   */
  dest?: string;
  /**
   * Internal working directory of ng-packagr where intermediate build files are stored (default: `.ng_pkg_build`).
   */
  workingDirectory?: string;
  /**
   * Description of the library that is being built.
   */
  lib?: {
      /**
     * Entry file to the public API of the library (default: `src/public_api.ts`).
     */
  entryFile?: string;
      /**
     * Filename of the auto-generated flat module file (if empty, defaults to the package name as given in `package.json`).
     */
  flatModuleFile?: string;
      /**
     * A symbol map of external dependencies. The purpose of this map is to correctly bundle a flat module file (with `rollup`). By default, `rxjs` and `@angular/*` dependency symbols are supported.
     */
  externals?: {
      [k: string]: any;
    };
      /**
     * A property to indicate whether your library is going to be bundling jsx/tsx files. This passes through to tsconfig - see https://www.typescriptlang.org/docs/handbook/jsx.html
     */
  jsx?: ("preserve" | "react" | "react-native");
      /**
     * Set typescript language level, i.e. tsconfig.lib. This will enable accessing typescript features available in es2016, es2017, etc.
     */
  languageLevel?: string[];
    [k: string]: any;
  };
}
